<div class="fab-container" #fabButton>
  <button mat-fab color="primary" (click)="togglePanel()">
    <ion-icon class="icon-animation" size='small' [class.open]="panelVisible" [name]="panelVisible ? 'close-sharp' : 'settings-sharp'"></ion-icon>
  </button>
</div>

<!-- Panel de configuración -->
<div class="card config-panel" *ngIf="panelVisible" #configPanel>
  <div class="card-header">
    <h2 class="text-header-primary m-0">Configuración</h2>
    <button mat-icon-button (click)="togglePanel()">
      <ion-icon name="close"></ion-icon>
    </button>
  </div>
  <div class="card-body">
    <p>Fuente de datos para las gráficas:</p>

    <div class="form-check">
      <input
        class="form-check-input"
        type="radio"
        name="dataSource"
        id="dataSourceTraditional"
        value="traditional"
        [checked]="selectedDataSource === 'traditional'"
        (change)="updateDataSource('traditional')">
      <label class="form-check-label" for="dataSourceTraditional">
        Nutrimac / Xilema
      </label>
    </div>

    <div class="form-check">
      <input
        class="form-check-input"
        type="radio"
        name="dataSource"
        id="dataSourceRDSPostgreSQL"
        value="postgresql"
        [checked]="selectedDataSource === 'postgresql'"
        (change)="updateDataSource('postgresql')">
      <label class="form-check-label" for="dataSourceRDSPostgreSQL">
        RDS PostgreSQL
      </label>
    </div>

    <div class="form-check">
      <input
        class="form-check-input"
        type="radio"
        name="dataSource"
        id="dataSourceAWSTimestream"
        value="timestream"
        [checked]="selectedDataSource === 'timestream'"
        (change)="updateDataSource('timestream')">
      <label class="form-check-label" for="dataSourceAWSTimestream">
        AWS Timestream
      </label>
    </div>

    <div class="form-check">
      <input
        class="form-check-input"
        type="radio"
        name="dataSource"
        id="dataSourceTimescaleDB"
        value="timescale"
        [checked]="selectedDataSource === 'timescale'"
        (change)="updateDataSource('timescale')">
      <label class="form-check-label" for="dataSourceTimescaleDB">
        TimescaleDB
      </label>
    </div>

    <div class="mt-4" *ngIf="selectedDataSource !== 'traditional'">
      <p>Método de obtención de datos:</p>

      <div class="form-check">
        <input
          class="form-check-input"
          type="radio"
          name="collectionMethod"
          id="collectionMethodGroupIntervals"
          value="group_intervals"
          [checked]="selectedCollectionMethod === 'group_intervals'"
          (change)="updateCollectionMethod('group_intervals')">
        <label class="form-check-label" for="collectionMethodGroupIntervals">
          Agrupación intervalos
        </label>
      </div>

      <div class="form-check" *ngIf="selectedDataSource === 'timestream'">
        <input
          class="form-check-input"
          type="radio"
          name="collectionMethod"
          id="collectionMethodInterpolateLinear"
          value="interpolate_linear"
          [checked]="selectedCollectionMethod === 'interpolate_linear'"
          (change)="updateCollectionMethod('interpolate_linear')">
        <label class="form-check-label" for="collectionMethodInterpolateLinear">
          Interpolación lineal
        </label>
      </div>

      <div class="form-check" *ngIf="selectedDataSource === 'timestream'">
        <input
          class="form-check-input"
          type="radio"
          name="collectionMethod"
          id="collectionMethodInterpolateSplineCubic"
          value="interpolate_spline_cubic"
          [checked]="selectedCollectionMethod === 'interpolate_spline_cubic'"
          (change)="updateCollectionMethod('interpolate_spline_cubic')">
        <label class="form-check-label" for="collectionMethodInterpolateSplineCubic">
          Interpolación splice cúbica
        </label>
      </div>
    </div>

    <p class="text-muted mt-4"><i>Esta configuración de aplicará a las próximas gráficas generadas.</i></p>
  </div>
</div>
